import React from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ulmsUrl,holibookUrl, username, password } from '../../Api';
import { LocationData, ComponentFamily, OperationTypeList, DistrictData, PortList} from '../../apidata/fetchapi';
import { useEffect, useState } from "react";
import Select from 'react-select';
import { encode } from "base-64";
import { DatePicker } from 'antd';
import Loader from '../../loader/Loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UpdateRetailOpportunity = () => {

    const { locationOptions }  = LocationData();
    const { comFamOptions }    = ComponentFamily();
    const { operatTypeListData }    = OperationTypeList();
    const { districtOptions }  = DistrictData();
    const { portListData }     = PortList();

    let base64 = require('base-64');
    const opportupdateurl = "/opportunity/update";
    const navigate = useNavigate();
    const [lead_id, setLeadId] = useState(base64.decode(useParams().id));
    const usr_token = localStorage.getItem('authToken');
    const usr_name = localStorage.getItem('name');
    const usr_id = localStorage.getItem('usrId');

    const initialData = {
        "lead_id": lead_id,
        "service_for": "",
        "origin": "",
        "destination": "",
        "port_origin": "",
        "port_destination": "",
        "business_tenure": "",
        "potential_rev": "",
        "potential_capex": "",
        "potential_ebitda": "",
        "expected_closure_date": "",
        "reference_url": "",
        "opportunity_desc": "",
        "opportunity_creater_id": usr_id,
        "opportunity_creater_name": usr_name,
        "usr_token": usr_token,
    }

    const optionarr = [
        { value: '4', label: 'Test1' },
        { value: '5', label: 'Test2' },
        { value: '2', label: 'Test3' },
        { value: '666666', label: 'Other' }
    ]

    const [opportunityRetUpdate, setOpportunityRetUpdate] = React.useState(initialData);
    const [leadViewData, setLeadViewData] = React.useState([""]);
    const [usermessage, setMessage] = React.useState('');
    const [selectedFile, setSelectedFile] = React.useState([]);
    const [Operationselected, setOperationSelected] = React.useState('');
    const [otherselected, setOtherSelected] = React.useState(optionarr[0]);
    const [locationSelected, setLocationSelected] = useState('');
    const [loading, setLoading] = useState(false);
    const [inputFields, setInputFields] = useState([
        {  
           operation_type: "", 
           area_required: '', 
           inventory_days: '', 
           avg_daily_inbound: '',
           avg_daily_outbound: '',
        }
    ]);

    const getOpportViewData = async () => {
        const arr = [];
        try {
            fetch(ulmsUrl.concat('/wip/opp_details') , {
                method: 'POST',
                body: JSON.stringify({lead_id, usr_token}),
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then((response) =>
                response.json()
            )
            .then((response) => {  
                let result = response;   
                console.log(result);
                setOpportunityRetUpdate(result.data);
                setInputFields(result.multi_data);
            });
        } catch (error) {
            console.log(error);
        }
    }
  
    useEffect(() => {
       getOpportViewData();
    }, []);


    const handleFormInput = (e) => {
        if (e && e.target) {
            const { name, value } = e.target;
            setOpportunityRetUpdate(oldValue => ({
                ...oldValue,
                [name]: value,
                "usr_token": usr_token,
            }))
        }
        if(ebidtaperc != 0){
            setOpportunityRetUpdate(oldValue => ({
            ...oldValue,
            "ebidta_perc": ebidtaperc,
          }))
        }
    };

    let ebidtaperc = 0;
    if(opportunityRetUpdate.exp_monthly_revenue != '' && opportunityRetUpdate.exp_monthly_expense){
      let revenue = Number(opportunityRetUpdate.exp_monthly_revenue);
      let expense = Number(opportunityRetUpdate.exp_monthly_expense);
      let ebitadata = (revenue - expense) / revenue;
      ebidtaperc = ebitadata * 100;
    }

    const handleOriginInput = (data) => {
        const test = data.label;
        setOpportunityRetUpdate(oldValue => ({
            ...oldValue,
            "origin": data,
        }))  
    }

    const handlePortOriginInput = (data) => {
        const test = data.label;
        setOpportunityRetUpdate(oldValue => ({
            ...oldValue,
            "port_origin": data,
        }))  
    }

    const handleDestinationInput = (data) => {
        const test = data.label;
        setOpportunityRetUpdate(oldValue => ({
            ...oldValue,
            "destination": data,
        }))  
    }

    const handlePortDestinationInput = (data) => {
        const test = data.label;
        setOpportunityRetUpdate(oldValue => ({
            ...oldValue,
            "port_destination": data,
        }))  
    }

    const handleOperTypeInput = (index,event) => { 
        const list = [...inputFields];
        list[index]["operation_type"] = event;

        setOpportunityRetUpdate(oldValue => ({
            ...oldValue,
            "multi_data": list,
        }))  
    };

    const addFields = () => {
        let newfield = { 
           operation_type: "", 
           area_required: '', 
           inventory_days: '', 
           avg_daily_inbound: '',
           avg_daily_outbound: '',
        }
        setInputFields([...inputFields, newfield])
    }

    const handleChange = (index, event) => {
       const { name, value } = event.target;
       const list = [...inputFields];
       list[index][name] = value;
       setOpportunityRetUpdate(oldValue => ({
        ...oldValue,
        "multi_data": list,
      }))  

    }

    const removeInputFields = (index, event) => {
        // setInputFields(inputFields.filter((v, i) => i !== index));
         const rows = [...inputFields];
         rows.splice(index, 1);
         setInputFields(rows);
    }


    const handleFileInput = (e) => {
        console.log(e.target.files); 
        setSelectedFile(e.target.files)
        console.log(selectedFile);
    };

    const handleFormSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();

        const createdata = {
            lead_id : lead_id,
            service_for: opportunityRetUpdate.service_for,
            origin :  opportunityRetUpdate.origin,
            destination :  opportunityRetUpdate.destination,
            port_origin :  opportunityRetUpdate.port_origin,
            port_destination :  opportunityRetUpdate.port_destination,
            business_tenure :  opportunityRetUpdate.business_tenure,
            potential_rev :  opportunityRetUpdate.potential_rev,
            potential_capex :  opportunityRetUpdate.potential_capex,
            potential_ebitda :  opportunityRetUpdate.potential_ebitda,
            expected_closure_date :  opportunityRetUpdate.expected_closure_date,
            reference_url :  opportunityRetUpdate.reference_url,
            opportunity_desc :  opportunityRetUpdate.opportunity_desc,
            multi_data: inputFields,
            opportunity_creater_id : usr_id,
            opportunity_creater_name : usr_name,
            usr_token : usr_token
        }

        const formData = new FormData();
        for(let i = 0; i < selectedFile.length; i++){
            formData.append(`opportunity_photo_web`, selectedFile[i]);
        }
        
        formData.append('data', JSON.stringify(createdata));
        console.log(JSON.stringify(createdata));

        fetch(ulmsUrl.concat(opportupdateurl), {
            method: 'POST',
            body: formData,
        })
        .then((result) =>
            result.json()
        )
        .then((result) => {
            console.log(result)
            if (result.status == true) {
                setOpportunityRetUpdate(initialData);
                // toast.success(result.message, {
                //     position: toast.POSITION.TOP_RIGHT,
                //     toastId: 'success1',
                // });
                sessionStorage.setItem("createmessage", result.message);
                setLoading(false);
                navigate("/all_leads", { replace: true });

            } else if (result.status == false) {
                setLoading(false);
                setOpportunityRetUpdate(opportunityRetUpdate);
                toast.error(result.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    toastId: 'success1',
                });
               
            }
        })
        .catch((form_err) => {
            //console.log(form_err)
        })
    }



  return (
    <>
        {/* {usermessage && <div className="alert alert-danger alert-dismissible fade show" role="alert">
           <strong>{usermessage}</strong>    
       </div>} */}
       <ToastContainer />
       {loading && (
          <>
            <Loader/>
          </>
        ) }
       <div className="row">
           <div className="order-2 order-lg-1 col-lg-12 bd-content">
               <div className="card">
                   <div className="card-header">
                       <h3 className="card-title">UPDATE OPPORTUNITY ( LEAD ID: {lead_id} )</h3>
                   </div>
                   <div className="card-body">
                       <div className="invoice row">
                            <div style={{float: 'left'}} className="table-scrollable col-md-6">
                                <table style={{marginTop: '20px'}} id="mainTable" className="table table-striped">
                                    <thead className="thead-light">
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>LOB</th>
                                            <td >{opportunityRetUpdate != '' && opportunityRetUpdate.project_type}</td>
                                        </tr>
                                        <tr>
                                            <th>Product Type</th>
                                            <td>{opportunityRetUpdate != '' && opportunityRetUpdate.products}</td>
                                        </tr>
                                        <tr>
                                            <th>Service Type</th>
                                            <td>{opportunityRetUpdate != '' && opportunityRetUpdate.service_type}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> 
                            <div className="table-scrollable col-md-6">
                                <table style={{marginTop: '20px'}} id="mainTable" className="table table-striped">
                                    <thead className="thead-light">
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>Customer Name</th>
                                            <td>{opportunityRetUpdate != '' && opportunityRetUpdate.supplier_name}</td>
                                        </tr>
                                        <tr>
                                            <th>Industry Vertical</th>
                                            <td>{opportunityRetUpdate != '' && opportunityRetUpdate.cust_industry_verticle}</td>
                                        </tr>
                                        <tr>
                                            <th>Start Date</th>
                                            <td >{opportunityRetUpdate != '' && opportunityRetUpdate.start_date}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> 
                            <div className="table-scrollable col-md-12">
                                <table style={{marginTop: '20px'}} id="mainTable" className="table table-striped">
                                    <thead className="thead-light">
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>Location</th>
                                            <td>{opportunityRetUpdate != '' && opportunityRetUpdate.supplier_loc}</td>
                                        </tr>
                                    
                                    </tbody>
                                </table>
                            </div> 
                        </div>
                       <form className="row g-3" encType="multipart/form-data" onSubmit={handleFormSubmit} style={{marginTop: '5px'}}>
                            <div className="col-md-12">  
                                <Form.Label style={{marginRight: '15px'}} >Service For :<span className="required-mark">*</span></Form.Label>
                                <Form.Check
                                    inline
                                    label="Domestic"
                                    name="service_for"
                                    value="Domestic"
                                    type= "radio"
                                    onClick={()=>setLocationSelected("Domestic")}
                                    onChange={handleFormInput}
                                    checked = {opportunityRetUpdate.service_for === "Domestic" ? true : false}
                                    id={`inline-radio-2`}
                                />
                                <Form.Check
                                    inline
                                    label="International"
                                    name="service_for"
                                    value="International"
                                    type= "radio"
                                    onClick={()=>setLocationSelected("International")}
                                    onChange={handleFormInput}
                                    checked = {opportunityRetUpdate.service_for === "International" ? true : false}
                                    id={`inline-radio-1`}
                                />
                            </div>
                            {(opportunityRetUpdate.service_for == "Domestic") &&
                            <>
                                <div className="col-md-4" style={{marginTop: '5px'}}>
                                    <label htmlFor="inputState" className="form-label"> Origin :<span className="required-mark">*</span> </label>
                                    <Select
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        name="origin"
                                        options={districtOptions}
                                        defaultValue={opportunityRetUpdate.origin}
                                        onChange={handleOriginInput}
                                        key={opportunityRetUpdate.origin}
                                    />
                                </div>
                                <div className="col-md-4" style={{marginTop: '5px'}}>
                                    <label htmlFor="inputState" className="form-label"> Destination :<span className="required-mark">*</span> </label>
                                    <Select
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        name="destination"
                                        options={districtOptions}
                                        defaultValue={opportunityRetUpdate.destination}
                                        onChange={handleDestinationInput}
                                        key={opportunityRetUpdate.destination}
                                    />
                                </div>
                            </>}
                            {opportunityRetUpdate.service_for == "International" &&
                            <>
                                <div className="col-md-4" style={{marginTop: '5px'}}>
                                    <label htmlFor="inputState" className="form-label"> Origin :<span className="required-mark">*</span> </label>
                                    <Select
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        name="port_origin"
                                        options={portListData}
                                        defaultValue={opportunityRetUpdate.port_origin}
                                        onChange={handlePortOriginInput}
                                        key={opportunityRetUpdate.port_origin}
                                    />
                                </div>
                                <div className="col-md-4" style={{marginTop: '5px'}}>
                                    <label htmlFor="inputState" className="form-label"> Destination :<span className="required-mark">*</span> </label>
                                    <Select
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        name="port_destination"
                                        options={portListData}
                                        defaultValue={opportunityRetUpdate.port_destination}
                                        onChange={handlePortDestinationInput}
                                        key={opportunityRetUpdate.port_destination}
                                    />
                                </div>
                            </>}
                            <div className="col-md-4" style={{marginTop: '5px'}}>
                                <label htmlFor="inputState" className="form-label">Business Tenure (In months) :<span className="required-mark">*</span> </label>
                                <Form.Control
                                    type="number"
                                    name="business_tenure"
                                    value={opportunityRetUpdate.business_tenure}
                                    onChange={handleFormInput}
                                    id="business_tenure"
                                    className="form-control" placeholder="Enter Business Tenure" />      
                            </div>
                            <div className="col-md-4" style={{marginTop: '5px'}}>
                                <label htmlFor="inputState" className="form-label">Potential Revenue :<span className="required-mark">*</span> </label>
                                <Form.Control
                                    type="number"
                                    name="potential_rev"
                                    value={opportunityRetUpdate.potential_rev}
                                    onChange={handleFormInput}
                                    id="potential_rev"
                                    className="form-control" placeholder="Enter Potential Revenue" />      
                            </div>
                            <div className="col-md-4" style={{marginTop: '5px'}}>
                                <label htmlFor="inputState" className="form-label">Potential Capex :<span className="required-mark">*</span> </label>
                                <Form.Control
                                    type="number"
                                    name="potential_capex"
                                    value={opportunityRetUpdate.potential_capex}
                                    onChange={handleFormInput}
                                    id="potential_capex"
                                    className="form-control" placeholder="Enter Potential Capex" />      
                            </div>
                            <div className="col-md-4" style={{marginTop: '5px'}}>
                                <label htmlFor="inputState" className="form-label">Potential Ebitda :<span className="required-mark">*</span> </label>
                                <Form.Control
                                    type="number"
                                    name="potential_ebitda"
                                    value={opportunityRetUpdate.potential_ebitda}
                                    onChange={handleFormInput}
                                    id="potential_ebitda"
                                    className="form-control" placeholder="Enter Potential Ebitda" />      
                            </div>
                            <div className="col-md-4" style={{marginTop: '5px'}}>
                                    <Form.Label>Expected Closure Date:<span className="required-mark">*</span></Form.Label>
                                    <Form.Control
                                    type="date"
                                    name="expected_closure_date"
                                    defaultValue={opportunityRetUpdate.expected_closure_date}
                                    onChange={handleFormInput}
                                    id="expected_closure_date"
                                    className="form-control"  />
                            </div>
                            <div className="col-md-4" style={{marginTop: '5px'}}>
                                <Form.Label>Reference url</Form.Label>
                                <Form.Control
                                    type="url"
                                    name="reference_url"
                                    value={opportunityRetUpdate.reference_url}
                                    onChange={handleFormInput}
                                    id="reference_url"
                                    className="form-control"  />
                            </div>
                            <div className="col-md-4"  style={{marginTop: '5px'}}>
                                <Form.Label>Opportunity Description :</Form.Label>
                                    <Form.Control 
                                        className="form-control"
                                        as="textarea"
                                        rows={1}
                                        placeholder="Enter Description"
                                        name="opportunity_desc"
                                        value={opportunityRetUpdate.opportunity_desc}
                                        onChange={handleFormInput}
                                        autoComplete='off'
                                    />   
                            </div>
                            {inputFields.map((input, index) => {
                              return (
                                <div className="row" key={index}>

                                    <div className="col-md-4" style={{marginTop: '5px'}}>
                                        <label htmlFor="inputState" className="form-label">Operation Type :<span className="required-mark">*</span> </label>
                                        <Select
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            name="oem_loc"
                                            options={operatTypeListData}
                                            onChange={(event)=>handleOperTypeInput(index,event)}
                                            defaultValue={input.operation_type}
                                            key={input.operation_type }
                                        />
                                    </div>
                                    <div className="col-md-4" style={{marginTop: '5px'}}>
                                        <label htmlFor="inputState" className="form-label">Area Required (Sq.ft.): <span className="required-mark">*</span></label>
                                        <Form.Control
                                            type="number"
                                            name="area_required"
                                            value={input.area_required}
                                            onChange={(event)=>handleChange(index, event)}
                                            id="area_required"
                                            className="form-control" placeholder="Enter area in sq. ft." 
                                            />      
                                    </div>
                                    <div className="col-md-4" style={{marginTop: '5px'}}>
                                        <label htmlFor="inputState" className="form-label">Inventory Days:<span className="required-mark">*</span> </label>
                                        <Form.Control
                                            type="number"
                                            name="inventory_days"
                                            value={input.inventory_days}
                                            onChange={(event)=>handleChange(index, event)}
                                            id="inventory_days"
                                            className="form-control" placeholder="Enter inventory days" 
                                            />      
                                    </div>
                                    <div className="col-md-4" style={{marginTop: '5px'}}>
                                        <label htmlFor="inputState" className="form-label">Avg. Daily Inbound:<span className="required-mark">*</span> </label>
                                        <Form.Control
                                            type="number"
                                            name="avg_daily_inbound"
                                            value={input.avg_daily_inbound}
                                            onChange={(event)=>handleChange(index, event)}
                                            id="avg_daily_inbound"
                                            className="form-control" placeholder="Enter daily avg. inbound" 
                                            />      
                                    </div>
                                    <div className="col-md-4" style={{marginTop: '5px'}}>
                                        <label htmlFor="inputState" className="form-label">Avg. Daily Outbound:<span className="required-mark">*</span> </label>
                                        <Form.Control
                                            type="number"
                                            name="avg_daily_outbound"
                                            value={input.avg_daily_outbound}
                                            onChange={(event)=>handleChange(index, event)}
                                            id="avg_daily_outbound"
                                            className="form-control" placeholder="Enter daily avg. outbound" 
                                            />      
                                    </div>
                                    <div className="col-md-4" style={{marginTop: '25px'}} >
                                        {(inputFields.length!==1)? <i className="btn btn-danger" style={{float: 'right', marginLeft:'8px'}} onClick={(event)=>removeInputFields(index,event)}>Remove</i>:''}
                                        <i className="btn btn-primary" onClick={addFields} style={{float: 'right'}}>Add More</i>
                                    </div>
                                </div>
                                )
                            })}
                            <div className="col-md-4" controlid="formFileMultiple" style={{marginTop: '5px'}}>
                                <Form.Label>Upload Photographs (File name should be in alphanumeric , - , _ , . ) :</Form.Label>
                                    <Form.Control multiple type="file"  
                                      name="opportunity_photo_web"
                                      onChange={handleFileInput}
                                    />
                            </div>
                            <div className="col-md-12" style={{marginTop: '15px'}}>
                                <button type="submit" className="btn btn-primary">Submit</button>
                            </div>    
                       </form>
                   </div>
               </div>
           </div>
       </div>
    </>
  )
}

export default UpdateRetailOpportunity